import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Fab } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import InvocationStrip from './InvocationStrip';
import SkipLink from '../common/SkipLink';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      let attempts = 0;
      const tick = () => {
        const el = document.getElementById(id);
        if (el) {
          const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
          el.scrollIntoView?.({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          return;
        }
        if (attempts < 24) {
          attempts += 1;
          requestAnimationFrame(tick);
        }
      };
      tick();
      return;
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}

export default function Layout() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <SkipLink />
      <ScrollToTop />
      <InvocationStrip />
      <Header />
      <main id="main-content">
        <Outlet />
      </main>
      <Footer />
      {showTop && (
        <Fab
          color="primary"
          size="medium"
          aria-label="Back to top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          sx={{ position: 'fixed', right: 20, bottom: 20, zIndex: 20, borderRadius: 1 }}
        >
          ↑
        </Fab>
      )}
    </>
  );
}
